<div class="bottommenu">

    <div *ngIf="pagemask==false">

        <div class="row ">
            <div class="myday col-4 d-flex justify-content-center">
                <a [routerLink]="['/myday']"> <i class="fa-solid fa-calendar-days"></i></a>             
            </div>
            <div class="menu col-4 d-flex justify-content-center">
                <a [routerLink]="['/menu']"><i class="fa-solid fa-house-chimney"></i></a>      
            </div>
            <div class="contact col-4 d-flex justify-content-center">
                <a [routerLink]="['/contact']"> <i class="fa-solid fa-user"></i></a>
            </div>      
        </div>
        <div class="row ">
            <div class="bottomenuwords col-4 d-flex justify-content-center">     
                <a [routerLink]="['/myday']">My Day</a>       
            </div>
            <div class="bottomenuwords col-4 d-flex justify-content-center">        
                <a [routerLink]="['/menu']"> Home</a>
            </div>
            <div class="bottomenuwords col-4 d-flex justify-content-center">      
                <a [routerLink]="['/contact']">Contact</a>
            </div>
        </div>

    </div>

    <div *ngIf="pagemask==true">

        <div class="row ">
            <div class="myday col-6 d-flex justify-content-center">
                <a [routerLink]="['/myday']"> <i class="fa-solid fa-calendar-days"></i></a>  
            </div>
            <div class="menu col-6 d-flex justify-content-center">
                <a [routerLink]="['/menu']"><i class="fa-solid fa-house-chimney"></i></a>
            </div>
        </div>
        <div class="row ">
            <div class="bottomenuwords col-6 d-flex justify-content-center">
                <a [routerLink]="['/myday']">First Day</a>
            </div>
            <div class="bottomenuwords col-6 d-flex justify-content-center"> 
                <a [routerLink]="['/menu']"> Home</a>
            </div>
        </div>

    </div>


</div>
